const refreshDMCrossSells = () => {
  const currentSection = document.querySelector('[data-dm-cart-cross-sells]');
  if (!currentSection || currentSection.dataset.refreshing === 'true') return;

  currentSection.dataset.refreshing = 'true';
  const sectionId = currentSection.dataset.sectionId;
  const sectionUrl = `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`;

  fetch(sectionUrl)
    .then((response) => response.text())
    .then((html) => {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const updatedSection = parsedHtml.querySelector('[data-dm-cart-cross-sells]');

      if (updatedSection) {
        currentSection.replaceWith(updatedSection);
      } else {
        currentSection.remove();
      }
    })
    .catch(() => {
      delete currentSection.dataset.refreshing;
    });
};

document.addEventListener('afterCartChanged', refreshDMCrossSells);
document.addEventListener('afterUpdateQuantity', refreshDMCrossSells);

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-dm-cart-cross-sells] quick-add-drawer-opener button');
  if (!opener) return;

  const item = opener.closest('.dm-cart-cross-sells__item');
  const dialog = item?.querySelector('[data-dm-variant-dialog]');
  if (!dialog) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
  dialog.showModal();
}, true);

document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('[data-dm-variant-close]');
  if (closeButton) {
    closeButton.closest('dialog')?.close();
    return;
  }

  const dialog = event.target.closest('[data-dm-variant-dialog]');
  if (dialog && event.target === dialog) dialog.close();
});

document.addEventListener('change', (event) => {
  const option = event.target.closest('[data-dm-variant-option]');
  if (!option) return;

  const form = option.closest('form');
  const variantInput = form?.querySelector('input[name="id"]');
  if (variantInput) variantInput.value = option.value;
});

document.addEventListener('afterCartChanged', () => {
  document.querySelectorAll('[data-dm-variant-dialog][open]').forEach((dialog) => dialog.close());
});
